/* Manu AI v36 (28/10/2026) — lien vers un exemple : /?exemple=<nom-de-l-exemple>.
 * Le lien ouvre l'accueil avec le champ de Manu déjà rempli par cet exemple (texte + style), comme si on avait cliqué sa carte.
 * - Le nom = le libellé de l'exemple en minuscules, sans accents, mots reliés par des tirets (« Amor por favor » → amor-por-favor).
 *   Reconnu dans toutes les langues du libellé ; /en/?exemple=… et ?example=… fonctionnent aussi.
 * - Rien n'est lancé : le visiteur lit, ajuste, puis clique « Créer avec Manu » (aucun coût déclenché par un lien).
 * - Exemple introuvable ou catégorie supprimée dans le back-office : le lien ne fait rien de plus que l'accueil normal.
 * - Pas de focus dans le champ : sur mobile le clavier ne s'ouvre pas à l'arrivée.
 * S'appuie sur section._ais enrichie par v9 → v30. */
(function () {
  'use strict';

  var HEROS = ['fitness', 'crossfit', 'hyrox', 'running'];

  function slug(s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function wanted() {
    var m = /[?&](?:exemple|example)=([^&#]+)/i.exec(location.search);
    if (!m) return '';
    try { return slug(decodeURIComponent(m[1].replace(/\+/g, ' '))); } catch (e) { return slug(m[1]); }
  }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v36 || !inst._v30) return;
    inst._v36 = true;

    // Remplit le champ avec l'exemple demandé (par le clic de sa carte : même texte, même style, même synchro que v9).
    // Renvoie true si l'exemple est trouvé.
    inst.exampleFromUrl = function (want) {
      want = want || wanted();
      if (!want || !inst.ideaField || !inst.promptsEl) return false;
      var data = (inst.exData && inst.exData.niches) || {}, loc = inst.loc, labels = [];
      Object.keys(data).forEach(function (k) {
        (data[k] || []).forEach(function (e) {
          if (!e || !e.label) return;
          var hit = Object.keys(e.label).some(function (l) { return slug(e.label[l]) === want; });
          if (hit) labels.push(e.label[loc] || e.label.fr);
        });
      });
      if (!labels.length) return false;
      // Liste courante d'abord, puis chaque sport ; une catégorie perso (hors sports) se trouve dans « Tous les sports »
      var tries = [inst.heroNiche || null].concat(HEROS, [null]), i, j, list, idx;
      for (i = 0; i < tries.length; i++) {
        list = inst.exList(tries[i]); idx = -1;
        for (j = 0; j < list.length; j++) if (labels.indexOf(list[j][0]) > -1) { idx = j; break; }
        if (idx < 0) continue;
        if ((tries[i] || null) !== (inst.heroNiche || null)) inst.setNiche(tries[i], true);
        var btn = inst.promptsEl.querySelector('[data-ex="' + idx + '"]');
        if (!btn) continue;
        var f = inst.ideaField;
        f.focus = function () {};            // pas de clavier ni de saut de page à l'arrivée
        try { btn.click(); } finally { delete f.focus; }
        return true;
      }
      return false;
    };
    inst.exampleFromUrl();
  }

  function boot(n) {
    n = typeof n === 'number' ? n : 0;
    document.querySelectorAll('[data-ais]').forEach(function (root) {
      var i = root._ais;
      if (i && i._v30) enhance(root);
      else if (n < 40) setTimeout(function () { boot(n + 1); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
})();
